<template>
  <CalicoOnboarding
    class="access-code"
    type="access-code"
    :loading="loading"
    :form-data="formData"
    @save="save"
  >
    <CalicoFormHeader />
    <p class="body--medium">
      Enter the access code provided by your company/employer. If you do not have an
      access code, contact your company’s administrator.
    </p>
    <CalicoForm
      v-slot="{ field, error }"
      label="Access Code"
      name="accessCode"
      rules="required"
    >
      <CalicoField
        v-model="formData.accessCode"
        v-bind="field"
        :error="error"
      />
    </CalicoForm>
    <Modal
      v-if="show"
      header="Access Code"
      @close="show = false"
    >
      <template #content>
        <div class="confirmation">
          <i class="bi bi-x-lg contained-icon-large" />
          <h1 class="heading--large">
            Access Denied
          </h1>
          <p class="body--medium">
            You’ve entered an incorrect or invalid access code, please try again. If you
            think this is a mistake, contact your company administrator.
          </p>
        </div>
      </template>
      <template #footer>
        <button
          class="button-utility"
          @click="show = false"
        >
          Close
        </button>
      </template>
    </Modal>
  </CalicoOnboarding>
</template>

<script>
import CalicoOnboarding from "@/components/template/onboarding/index.vue";
import CalicoFormHeader from "@/components/calico/formHeader/index.vue";
import CalicoForm from "@/components/pattern/form/index.vue";
import CalicoField from '@/components/calico/field/index.vue';
import Modal from '@/components/template/modal/index.vue'
import services from "@/services";

export default {
    name: 'AccessCode',
    components: {
        CalicoOnboarding,
        CalicoFormHeader,
        CalicoForm,
        CalicoField,
        Modal
    },
    data() {
        return {
            formData: {
                accessCode: ""
            },
            loading: false,
            show: false
        }
    },
    methods: {
        async save(next) {
            this.loading = true
            const verifyAccessCode = await services.organization.verifyAccessCode(this.formData)
            if (verifyAccessCode) {
                next()
            } else {
                this.show = true
            }
            this.loading = false
        }
    }

};
</script>

<style scoped lang="scss">
.access-code {
    @include stack-space($space-large);

    .confirmation {
        @include stack-space($space-small);
        align-items: center;
        justify-content: center;
        padding: $space-xxlarge $space-large;

        i {
            background-color: $color-semantics-error;
            border: none;
            color: white;
        }

        p {
            margin: 0;
            text-align: center;
        }
    }
}
</style>